/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';

import {
    PanelBody,
    SelectControl,
	__experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption,
	RangeControl
} from '@wordpress/components';

import {
    useState
} from '@wordpress/element';

import {
		VayuBlocksColorControl,
		HeightControl,
		VayuBlocksBackground,
		GroupControl
	} from '@vayu-blocks';

import {VayuBlocksDeviceControl} from '@vayu-blocks/device-control';
import { SlideButton } from '@vayu-blocks/global';

const ConatinerStylePanel = ({
            attributes,
            setAttributes,
			openPanels, 
			onTogglePanel }) => {

	const [hover, sethover] = useState('normal');
	const handelHover = (value) => {
        sethover(value);
        if (typeof clickBorderHover === 'function') {
            clickBorderHover(value);
        }
    }
	const [ shaper, setShaper ] = useState( 'top' );
	const handelShape = (value) => {
        setShaper(value);
        if (typeof clickBorderHover === 'function') {
            clickBorderHover(value);
        }
    }

    return (
        <>
        <PanelBody
						title={ __( 'Overlay', 'vayu-blocks' ) }
						opened={openPanels['vb-conatiner-overlay']} onToggle={() => onTogglePanel('vb-conatiner-overlay')}
						> 

						 <SlideButton  
							button={{ normal: "Normal", hover: "Hover" }}
								onChange={(value)=>handelHover(value)}
								defaultValue={'normal'}
						  />

						  {hover === 'normal' && (
								   <VayuBlocksColorControl
									onChange={(key, value) => setAttributes({ [key]: value })}
									background={{ value: attributes.overlaybackground, backgroundKey: 'overlaybackground' }}
									/>
							)}
								{hover === 'hover' && (
								<VayuBlocksColorControl
									onChange={(key, value) => setAttributes({ [key]: value })}
									background={{ value: attributes.overlaybackgroundHover, backgroundKey: 'overlaybackgroundHover' }}
								/>
							)}
                        
						</PanelBody>

						<PanelBody
						title={ __( 'Background', 'vayu-blocks' ) }
						opened={openPanels['vb-conatiner-background']} onToggle={() => onTogglePanel('vb-conatiner-background')}
						> 

						 <SlideButton  
							button={{ normal: "Normal", hover: "Hover" }}
								onChange={(value)=>handelHover(value)}
								defaultValue={'normal'}
						  />

						  {hover === 'normal' && (
								<VayuBlocksColorControl
									onChange={(key, value) => setAttributes({ [key]: value })}
									background={{ value: attributes.advBackground, backgroundKey: 'advBackground' }}
									video = {true}
									/>
							)}
								{hover === 'hover' && (
								<VayuBlocksColorControl
									onChange={(key, value) => setAttributes({ [key]: value })}
									background={{ value: attributes.advBackgroundHover, backgroundKey: 'advBackgroundHover' }}

								/>
							)}
                        
						</PanelBody>
						<PanelBody
						title={ __( 'Shape Divider', 'vayu-blocks' ) }
						opened={openPanels['vb-conatiner-shape']} onToggle={() => onTogglePanel('vb-conatiner-shape')}
						> 
                        <SlideButton
							button={{ top: "Top", bottom: "Bottom" }}
								onChange={(value)=>handelShape(value)}
								defaultValue={'top'}
						/>
                        { 'top' ===  shaper &&  (
							<>
                            <SelectControl
								value={ attributes.shapeTop }
								onChange={ e => setAttributes({ shapeTop: e }) }
								options={ [
									{ label:  __( 'default', 'vayu-blocks' ), value: 'default' },
									{ label: __( 'curve', 'vayu-blocks' ), value: 'curve' },
									{ label: __( 'triangle', 'vayu-blocks' ), value: 'triangle' },
                                    { label: __( 'wave', 'vayu-blocks' ), value: 'wave' },
                                    { label: __( 'mountain', 'vayu-blocks' ), value: 'mountain' },         
								] }
				             	/>
								 <VayuBlocksBackground
										onChange={(key,value)=>setAttributes({[key]:value})}
											colorPanel = {[
													{
														active: ['color'],
														label: 'color',
														key:'shapeTopClr',
														value:attributes.shapeTopClr
																					
													}								
												]}
									/>   
									<HeightControl
										label={__('Width', 'vayu-blocks')}
										value={attributes.shapeTopWidth}
										onChange={ (value) => setAttributes({shapeTopWidth: value }) }
										responsive={true}
										customUnits={['px','%','em']}
									/>
                                     <HeightControl
										label={__('Height', 'vayu-blocks')}
										value={attributes.shapeTopHeight}
										responsive={true}
										onChange={ (value) => setAttributes({shapeTopHeight: value }) }
										customUnits={['px','%','em']}
									/>

						           <ToggleGroupControl
									label={ __( 'Flip', 'vayu-blocks' ) }
									value={ attributes.shapeTopFlip }
									onChange={ (shapeTopFlip) => setAttributes({ shapeTopFlip }) }
									isBlock
									__nextHasNoMarginBottom
									__next40pxDefaultSize
								    >
									<ToggleGroupControlOption value={ true } label={ __( 'On', 'vayu-blocks' ) } />
									<ToggleGroupControlOption value={ false } label={ __( 'Off', 'vayu-blocks' ) } />
								    </ToggleGroupControl>

									<ToggleGroupControl
									label={ __( 'Bring to Front', 'vayu-blocks' ) }
									value={ attributes.shapeTopFront }
									onChange={ (shapeTopFront) => setAttributes({ shapeTopFront }) }
									isBlock
									__nextHasNoMarginBottom
									__next40pxDefaultSize
								    >
									<ToggleGroupControlOption value={ true } label={ __( 'On', 'vayu-blocks' ) } />
									<ToggleGroupControlOption value={ false } label={ __( 'Off', 'vayu-blocks' ) } />
								</ToggleGroupControl>
									
									
								 </>
						) || 'bottom' ===  shaper && (
                            <>
                            <SelectControl
								value={ attributes.shapeBottom }
								onChange={ e => setAttributes({ shapeBottom: e }) }
								options={ [
									{ label:  __( 'default', 'vayu-blocks' ), value: 'default' },
									{ label: __( 'curve', 'vayu-blocks' ), value: 'curve' },
									{ label: __( 'triangle', 'vayu-blocks' ), value: 'triangle' },
                                    { label: __( 'wave', 'vayu-blocks' ), value: 'wave' },
                                    { label: __( 'mountain', 'vayu-blocks' ), value: 'mountain' },         
								] }
				             	/>
								 <VayuBlocksBackground
										onChange={(key,value)=>setAttributes({[key]:value})}
											colorPanel = {[
													{
														active: ['color'],
														label: 'color',
														key:'shapeBottomClr',
														value:attributes.shapeBottomClr
																					
													}								
												]}
									/> 
		
								 <HeightControl
										label={__('Width', 'vayu-blocks')}
										value={attributes.shapeBottomWidth}
										onChange={ (value) => setAttributes({shapeBottomWidth: value }) }
										customUnits={['px','%','em']}
										responsive={true}
										unitMazx={{px:{max:1700, step:1}}}
									/>
                                <HeightControl
										label={__('Height', 'vayu-blocks')}
										value={attributes.shapeBottomHeight}
										responsive={true}
										onChange={ (value) => setAttributes({shapeBottomHeight: value }) }
										customUnits={['px','%','em']}
									/>

                                   <ToggleGroupControl
									label={ __( 'Flip', 'vayu-blocks' ) }
									value={ attributes.shapeBottomFlip }
									onChange={ (shapeBottomFlip) => setAttributes({ shapeBottomFlip }) }
									isBlock
									__nextHasNoMarginBottom
									__next40pxDefaultSize
								    >
									<ToggleGroupControlOption value={ true } label={ __( 'On', 'vayu-blocks' ) } />
									<ToggleGroupControlOption value={ false } label={ __( 'Off', 'vayu-blocks' ) } />
								    </ToggleGroupControl>

									<ToggleGroupControl
									label={ __( 'Bring to Front', 'vayu-blocks' ) }
									value={ attributes.shapeBottomFront }
									onChange={ (shapeBottomFront) => setAttributes({ shapeBottomFront }) }
									isBlock
									__nextHasNoMarginBottom
									__next40pxDefaultSize
								    >
									<ToggleGroupControlOption value={ true } label={ __( 'On', 'vayu-blocks' ) } />
									<ToggleGroupControlOption value={ false } label={ __( 'Off', 'vayu-blocks' ) } />
								</ToggleGroupControl>

								 </>
						)}
                        </PanelBody>
						<PanelBody
						title={ __( 'Slide', 'vayu-blocks' ) }
						opened={openPanels['vb-conatiner-slide']} onToggle={() => onTogglePanel('vb-conatiner-slide')}
						> 
						<SelectControl
								value={ attributes.innerContSlide }
								onChange={ e => setAttributes({ innerContSlide: e }) }
								options={ [
									{ label:  __( 'None', 'vayu-blocks' ), value: 'none' },
									{ label: __( 'Marquee Slide', 'vayu-blocks' ), value: 'marquee-slide' },
								] }
				             	/>

								{attributes.innerContSlide === 'marquee-slide' && (
                                <>
								<RangeControl
															label={__('Speed', 'vayu-blocks')}
															value={attributes.slideSpeed}
															onChange={(value) => setAttributes({slideSpeed: value})}
															step={0.1}
															min={0}
															max={5}
															allowReset={true}
														/>

														<SelectControl
								value={ attributes.slideDirection }
								onChange={ e => setAttributes({ slideDirection: e }) }
								options={ [
									{ label:  __( 'Right-To-Left', 'vayu-blocks' ), value: 'right-to-left' },
									{ label: __( 'Left-To-Right', 'vayu-blocks' ), value: 'left-to-right' },
								] }
								

				             	/>
								<h4>{__('Stop On Hover', 'vayu-blocks')}</h4>
									<GroupControl
										label={__('Stop On Hover', 'vayu-blocks')}
										value={ attributes.slideOnHover}
										onChange={ e => setAttributes({slideOnHover : e }) }		
										options={[
											{
												
												label: __( 'ON', 'vayu-blocks' ),
												value: 'true'
											},
											{
												
												label: __( 'OFF', 'vayu-blocks' ),
												value: 'false'
											}
										]}
										hasIcon = {false}
									  /> 
								</>
								)}
							
						
						</PanelBody>
                        </>
    );

}


export default ConatinerStylePanel;